import React from "react";

import TodoList from "../task/TodoList";
import CardLogic from "./CardLogic";

import './TodoLists.css';

import {addDays, startOfWeek} from 'date-fns'
import RequirementDetails from "./RequirementDetails";
import IconButton from "@material-ui/core/IconButton";
import ArrowDropDownOutlinedIcon from "@material-ui/icons/ArrowDropDownOutlined";
import ArrowDropUpOutlinedIcon from "@material-ui/icons/ArrowDropUpOutlined";

class TodoLists extends React.Component {
    dateOptions = {weekStartsOn:1};

    constructor(props) {
        super(props);
        console.log("TodoLists:", props);

        this.cardLogic = new CardLogic();

        this.state = {
            selectedCard: undefined,
            now: new Date(),
        };

        this.remove = this.remove.bind(this);
        this.select = this.select.bind(this);
    }

    componentDidMount() {
        if(this.props.element.id) {
            this._reload();
        }

        if(this.props.newElement) {
            this.getCategories();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this._readyToGet(this.props) && !this._readyToGet(prevProps)) {
            this._reload();
        } else if(this.props.version !== prevProps.version) {
            this._reload();
        }

        if(this.props.newElement && !(this.prevProps && this.prevProps.newElement) && !this.state.categories) {
            this.getCategories();
        }
    }

    _reload() {
        this.getTodoAndFutureCards();
        this.getDoneCards();
    }

    _readyToGet(props) {
        return props.user && props.user.id && props.element.id;
    }

    getCategories() {
        let element = this.props.element;
        let userId = `User/${this.props.user.id}`;
        let request = `/model/${element.type}/${element.id}/recursively?collections=categories&_members=${userId}`;

        return this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (response) => {
                    console.log('TodoLists getCategories:', response);
                    this.setState({
                        categories: response,
                    });
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    getDoneCards() {
        let userId = `User/${this.props.user.id}`;
        let today = new Date();

        // let from = startOfYear(today, this.dateOptions);
        let from = addDays(startOfWeek(today, this.dateOptions), -7);

        let fromDate = this.day(from.toISOString());
        // let toDate = this.day(today.toISOString());
        // let request = `/model/Card?status=Done&_members=${userId}&updatedTime=>=${fromDate}&updatedTime=<=${toDate}`;
        let request = `/model/Card?status=Done&_members=${userId}&updatedTime=>=${fromDate}`;
        this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (response) => {
                    console.log('TodoLists DONE from', fromDate, ':', response.length);
                    this.setState({
                        done: response,
                        cards: this.joinAllCards(response, this.state.todo),
                        now: new Date(),
                    });
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    getTodoAndFutureCards() {
        let userId = `User/${this.props.user.id}`;

        let request = `/model/Card?status=To do/Future&_members=${userId}`;
        this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (response) => {
                    console.log('TodoLists TODO and FUTURE:', response.length);
                    this.setState({
                        todo: response,
                        cards: this.joinAllCards(this.state.done, response),
                        now: new Date(),
                    });
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    joinAllCards(done, todo) {
        let cards = [].concat(done || [], todo || []);
        console.log("TodoLists:", cards.length, "cards in total:", cards);
        return cards;
    }

    render() {
        if(!this.state.cards) {
            console.log("* TodoLists: not ready");
            return null;
        }

        let today = this.day(this.state.now.toISOString());
        let groups = this.cardLogic.groupByDateAndCategory(this.state.cards, today, this.props.user);
        let groupsByTime = {};
        groups.filter(group => {
            if(group.time === this.cardLogic.Time.PAST) {
                return this.props.pastVisible;
            } else if(group.time === this.cardLogic.Time.FUTURE) {
                return this.props.futureVisible;
            } else {
                return true;
            }
        }).forEach(group => {
            let groupComponents = this.renderGroup(group);
            if(groupComponents) {
                if(!groupsByTime[group.time]) {
                    groupsByTime[group.time] = [];
                }
                groupsByTime[group.time].push(groupComponents);
            }
        });
        console.log("* TodoLists groupsByTime:", groupsByTime);
        let timePeriods = new Set(groups.map(group => group.time));

        let components = [];

        if(this.props.pastVisible) {
            if(groupsByTime[this.cardLogic.Time.PAST]) {
                groupsByTime[this.cardLogic.Time.PAST].forEach(groupComponents => {
                    components.push(groupComponents);
                });
            } else {
                components.push(this.renderEmtpyGroup("nothingDone", "No goals completed recently"));
            }
        }

        components.push(
            <div className={"showPast" + (this.props.pastVisible ? " line-above" : "")} key="togglePast">
                <IconButton aria-label="past" onClick={() => {
                    this.props.setPastVisible(!this.props.pastVisible);
                    // if(this.props.pastVisible && this.state.selectedCard && this.state.selectedCard) {
                    //     console.log("TodoLists hide past: Maybe deselect ", this.state.selectedCard);
                    // }
                }}>
                    <ArrowDropUpOutlinedIcon />
                </IconButton>
            </div>
        );

        if(groupsByTime[this.cardLogic.Time.PRESENT]) {
            groupsByTime[this.cardLogic.Time.PRESENT].forEach(groupComponents => {
                components.push(groupComponents);
            });
        } else {
            let statusText = timePeriods.has(this.cardLogic.Time.PAST) ? "All done" : "Nothing to do right now";
            components.push(this.renderEmtpyGroup("nothingTodo", statusText));
        }

        components.push(
            <div className={"showFuture" + (this.props.futureVisible ? " line-below" : "")} key="toggleFuture">
                <IconButton aria-label="future" onClick={() => this.props.setFutureVisible(!this.props.futureVisible)}>
                    <ArrowDropDownOutlinedIcon/>
                </IconButton>
            </div>
        );

        if(this.props.futureVisible) {
            if(groupsByTime[this.cardLogic.Time.FUTURE]) {
                groupsByTime[this.cardLogic.Time.FUTURE].forEach(groupComponents => {
                    components.push(groupComponents);
                });
            } else {
                components.push(this.renderEmtpyGroup("nothingPlanned", "Future plans will be shown here"));
            }
        }

        if(this.props.newElement && this.state.categories) {
            components.push(
                <div className="details details-create" key="new-card">
                    <RequirementDetails
                        globals={this.props.globals}
                        metamodel={this.props.metamodel}
                        showStatus={true}
                        collection={this.props.newElement.collection}
                        element={this.props.newElement.values}
                        categories={this.state.categories}
                        onChildAdded={(parent, child) => {
                            console.log("TodoLists.onChildAdded:", child.id);
                            this.select(child);
                            this.props.onChildAdded();
                            this._reload();
                        }}
                        create="true"
                        onCancel={this.props.cancelNewRequirement}
                    />
                </div>);
        }

        return components;
    }

    renderEmtpyGroup(key, text) {
        return (
            <div className="group-empty" key={key}>
                {text}
            </div>
        );
    }

    renderGroup(group) {
        let useFilter = group.time === 'present' || group.time === 'future';

        let components = group.categories.map(
            category => this.renderCategory(group, category, useFilter)
        ).filter(component => !!component);

        console.log("TodoLists.renderGroup", group.name, group.time, ":", components.length, "cards");

        return components.length > 0 &&
            <div className="group" key={group.name}>
                <div className="group-name">
                    {group.name}
                </div>
                {components}
            </div>;
    }

    renderCategory(group, category, useFilter) {
        let todoLists = category.cards && category.cards.map(
            card => this.renderCard(group, category, card, useFilter)
        ).filter(component => component);

        if(!todoLists || todoLists.length === 0) {
            // console.log("TodoLists renderCategory", categoryGroup, ": null");
            return null;
        }

        return (
            // TODO this key is not unique
            <div className="category-name" key={category.id + '/' + group.id}>
                {category.name}
                {todoLists}
            </div>);
    }

    remove(element) {
        console.log("TodoLists remove", element);

        this.props.globals.deleteElement(element).then(
            (result) => {
                console.log("Result", result);
                this._reload();
            },
            (error) => {
                console.error(error);
            }
        )
    }

    select(card) {
        console.log("TodoLists.select", card && card.id);

        if(card) {
            let today = new Date();
            let group = this.cardLogic.cardGroup(card, today, this.props.user);
            let dateGroup = this.cardLogic.buildDateGroup(today, group);
            console.log("TodoLists.select card:", card, ", group:", group, ", dateGroup:", dateGroup);

            if(dateGroup.time === this.cardLogic.Time.FUTURE && !this.props.futureVisible) {
                console.log("TodoLists.select: Show future cards");
                this.props.setFutureVisible(true);
            }
            if(dateGroup.time === this.cardLogic.Time.PAST && !this.props.pastVisible) {
                console.log("TodoLists.select: Show past cards");
                this.props.setPastVisible(true);
            }
        }

        this.setState({selectedCard: card && card.id});
    }

    renderCard(categoryGroup, category, card, useFilter) {
        if(useFilter && this.props.filter.openTasks) {
            if(card.status2 !== 'To do') {
                // console.log("TodoLists: Filter on openTasks; don't show card", card.id, card.name);
                return null;
            }
        }

        const tasks = this.props.metamodel.requirement.tasks(card);
        if(useFilter && this.props.filter.onlyShowMyTasksInDoMode && tasks.length === 0) {
            if (this.props.filter.user || this.props.filter.openTasks) {
                // console.log("TodoLists: Filter on user and openTasks; don't show card", card.id, card.name);
                return null;
            }
        }

        // console.log("TodoLists filter:", this.props.filter);

        return <div key={card.id} className="todoList">
            <TodoList
                className="todoList"
                globals={this.props.globals}
                metamodel={this.props.metamodel}
                user={this.props.user}
                users={this.props.users}
                userMap={this.props.userMap}
                element={card}
                groupName={categoryGroup.name}
                select={this.select}
                selected={card.id === this.state.selectedCard}
                filter={this.props.filter}
                tasks={tasks}
                labels={this.labels}
                styles={this.props.styles}
                remove={this.remove}
                refresh={() => this.setState({now: new Date()})}
            />
        </div>;
    }

    todoList(element, prev) {
        if(element.type !== 'Card') {
            return null;
        }

        // TodoList will do the same. But it is needed when adding and removing tasks.
        const tasks = this.props.metamodel.requirement.tasks(element);

        // TODO Also check if plannedStart is the same.
        let parent;
        if(element.parent.id !== prev.parentId) {
            parent = element.parent;
            prev.parentId = parent.id;
        }

        if(tasks.length === 0) {
            if(this.props.filter.user || this.props.filter.openTasks) {
                return null;
            }
            console.log("todoList", element, ". filter:", this.props.filter, ", No tasks");
        }

        // if(element.status !== 'To do') {
        //     console.log("Todolists not rendering", element);
        //     return null;
        // }

        let todoList = <TodoList
            className="todoList"
            globals={this.props.globals}
            metamodel={this.props.metamodel}
            users={this.props.users}
            userMap={this.props.userMap}
            element={element}
            filter={this.props.filter}
            tasks={tasks}
        />;

        return <div className="category">
            {parent &&
                <div className="category-name">
                    {parent.name}
                </div>
            }
            <div key={element.id} className="todoList">
                {todoList}
            </div>
        </div>;
    }

    day(date) {
        return date.split('T')[0];
    }
}

export default TodoLists;
